<div class="flyout-recommendation">
  <div class="flyout-recommendation-header">
    <h3 class="flyout-recommendation-title">
      {{ flyoutOpeningData.recommendationHeadingKey | translate: flyoutOpeningData.recommendationHeadingParams }}
    </h3>
    <button type="button" class="flyout-recommendation-close" [attr.aria-label]="'generic.close' | translate" (click)="closeFlyout()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (flyoutOpeningData.recommendationDetail; as detail) {
    <p class="flyout-recommendation-explanation">{{ detail.explanationKey | translate }}</p>

    <h4 class="flyout-recommendation-blocks-title">
      {{ "new-primary-dashboard.opportunities.detail.recommended-actions" | translate }}
    </h4>

    @for (block of detail.blocks; track block.headingKey) {
      <section class="recommendation-block">
        <h5 class="recommendation-block-heading">{{ block.headingKey | translate }}</h5>
        <p class="recommendation-block-text">{{ block.textKey | translate }}</p>
        <div class="recommendation-block-actions">
          @for (button of block.buttons; track button.labelKey) {
            <button
              type="button"
              class="recommendation-action"
              [disabled]="!button.route"
              [matTooltip]="button.route ? '' : ('new-primary-dashboard.opportunities.detail.action-pending' | translate)"
              (click)="start(button)">
              {{ button.labelKey | translate }}
            </button>
          }
        </div>
      </section>
    }
  }
</div>
